import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterMatchdayEvaluation} from "@/modules/competitions/events/AfterMatchdayEvaluation";
import TableStatisticsGenerator from "@/modules/competitions/services/stats/TableStatisticsGenerator";
import {LeagueDivision} from "@/modules/competitions/entity";

@injectable()
export class TableStatisticsEventSubscriber implements EventSubscriber {
  constructor(
    @inject(TableStatisticsGenerator) protected tableStatisticsGenerator: TableStatisticsGenerator,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterMatchdayEvaluation, callback: this.afterMatchdayEvaluation},
    ];
  }

  async afterMatchdayEvaluation(event: AfterMatchdayEvaluation): Promise<void> {
    await event.matchday.load('division');

    if (event.matchday.division instanceof LeagueDivision) {
      await this.tableStatisticsGenerator.increment(event.matchday);
    }
  }
}